import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { EMPTY, Subject } from 'rxjs';
import { catchError, concatMap, takeUntil } from 'rxjs/operators';
import { TranslocoService } from '@ngneat/transloco';

import { AuthService } from '../../services/auth.service';
import { DocumentService } from "../../services/document.service";
import { ReCaptchaV3Service } from "ng-recaptcha";

@Component({
  selector: 'app-forgotpw',
  templateUrl: './forgotpw.component.html',
  styleUrls: ['./forgotpw.component.scss']
})
export class ForgotpwComponent implements OnInit {
  isVerifyingEmail = true;
  passwordVisible = false;

  emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z]+[a-z0-9.-]+\.[a-z]{2,4}$/;
  email = new FormControl('', [Validators.required, Validators.pattern(this.emailReg)]);

  pwReg = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,12}$/;
  password = new FormControl('', [Validators.required, Validators.minLength(3)]);
  pwValidatorRes = {letter: false, number: false, special: false, length: false};
  verifyCode = new FormControl('', [Validators.required]);
  loading = false;
  logo = '';
  destroy$ = new Subject();

  constructor(
    private authService: AuthService,
    private notificationService: NzNotificationService,
    private router: Router,
    private translocoService: TranslocoService,
    private documentService: DocumentService,
    private recaptchaV3Service: ReCaptchaV3Service,
  ) {
  }

  ngOnInit(): void {
    this.onPwChanged();
    this.getLogo();
  }

  getVerifyCode(): void {
    this.loading = true;

    this.recaptchaV3Service.execute('forgotpw').pipe(
      catchError(() => {
        this.notificationService.error(
          '',
          this.translocoService.translate('common.failed'),
        );
        return EMPTY;
      }),
      concatMap((token) => {
        this.authService.setValueRecapcha(token);
        return this.authService
          .getVerifyCode(this.email.value)
          .pipe(
            catchError(() => {
              this.loading = false;
              this.notificationService.error(
                '',
                this.translocoService.translate('forgotPw.getVerifyCodeFailed')
              );
              return EMPTY;
            })
          )
      })
    ).subscribe(() => {
      this.loading = false;
      this.notificationService.success(
        this.translocoService.translate('forgotPw.getVerifyCodeSuccessfulTitle'),
        this.translocoService.translate('forgotPw.getVerifyCodeSuccessfulMsg')
      );
      this.isVerifyingEmail = false;
    });
  }

  changePassword(): void {
    this.loading = true;

    this.recaptchaV3Service.execute('changepw').pipe(
      catchError(() => {
        this.notificationService.error(
          '',
          this.translocoService.translate('common.failed'),
        );
        return EMPTY;
      }),
      concatMap((token) => {
        this.authService.setValueRecapcha(token);
        return this.authService
          .changePassword(this.email.value, this.verifyCode.value, this.password.value, this.password.value)
          .pipe(
            catchError(() => {
              this.loading = false;
              this.notificationService.error(
                '',
                this.translocoService.translate('forgotPw.changePasswordFailed')
              );
              return EMPTY;
            })
          )
      })
    ).subscribe(() => {
      this.loading = false;
      this.notificationService.success(
        this.translocoService.translate('forgotPw.changePasswordSuccessfulTitle'),
        this.translocoService.translate('forgotPw.changePasswordSuccessfulMsg')
      );
      this.router.navigateByUrl('login');
    });
  }

  onPwChanged() {
    this.password.valueChanges.subscribe((value) => {
      // this.pwValidatorRes.letter = /[a-zA-Z]/.test(value);
      // this.pwValidatorRes.number = /[0-9]/.test(value);
      // this.pwValidatorRes.special = /[!@#$%^&*]/.test(value);
      // this.pwValidatorRes.length = value.length > 7 && value.length < 13;
      this.pwValidatorRes.length = value.length > 2;
    });
  }

  getLogo() {
    this.logo = this.documentService.getLogoPage();
    if (!this.logo) {
      this.documentService.getLogo().pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          this.logo = res.logo;
          this.documentService.setLogoPage(this.logo);
        }
      })
    }
  }
}
